// extracted by mini-css-extract-plugin
export default {"whole":"ShopCumb_whole__3ya7y","content":"ShopCumb_content__EWtF3","bear":"ShopCumb_bear__3K0pD","noLink":"ShopCumb_noLink__azHAn"};